var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.80173 12.6667L1.83203 15V2.66667C1.83203 2.29848 2.13051 2 2.4987 2H14.4987C14.8669 2 15.1654 2.29848 15.1654 2.66667V12C15.1654 12.3682 14.8669 12.6667 14.4987 12.6667H4.80173ZM4.34058 11.3333H13.832V3.33333H3.16536V12.2567L4.34058 11.3333ZM7.83203 6.66667H9.16536V8H7.83203V6.66667ZM5.16536 6.66667H6.4987V8H5.16536V6.66667ZM10.4987 6.66667H11.832V8H10.4987V6.66667Z",
    fill: "#A3A3A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.ad7f4a1b33f2ac204fced25651ae76f6.svg";
export { ForwardRef as ReactComponent };